<script setup lang="ts">
import LogoDark from './LogoDark.vue';
</script>
<template>
  <LogoDark />
</template>
